import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 903,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						alignItems: "flex-start",
					}}>
					<div 
						style={{
							flexShrink: 0,
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 20,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/a9gphje0_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/1eapgp4h_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/n6yutvd1_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/w8yikyi5_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7bhzi164_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/wpqulqw5_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Chats"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/cvsy88zw_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Curriculum"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/gpux28ft_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 32,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/60fdclpt_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingTop: 8,
									paddingBottom: 8,
									paddingLeft: 8,
									paddingRight: 11,
									marginBottom: 22,
									marginLeft: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/fooly2vr_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 68,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/wm2veahj_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Progress"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 16,
										width: 64,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/q0qa415z_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							flex: 1,
							display: "flex",
							flexDirection: "column",
							gap: 32,
						}}>
						<div 
							style={{
								alignSelf: "stretch",
								display: "flex",
								alignItems: "center",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 32,
								paddingRight: 32,
							}}>
							<div 
								style={{
									flex: 1,
									display: "flex",
									alignItems: "center",
									background: "#F6F7F9",
									borderRadius: 8,
									paddingTop: 14,
									paddingBottom: 14,
									marginRight: 257,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/e40gon11_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										marginLeft: 20,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"For quick access to mentees or posts"}
									value={input2}
									onChange={(event)=>onChangeInput2(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										flex: 1,
										alignSelf: "stretch",
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									flexShrink: 0,
									display: "flex",
									alignItems: "center",
									background: "#FEF0E9",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 20,
									paddingRight: 23,
									marginRight: 32,
									gap: 8,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dr3k8xgl_expires_30_days.png"} 
									style={{
										width: 32,
										height: 32,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#F57E47",
										fontSize: 17,
										fontWeight: "bold",
									}} >
									{"Ask Giia"}
								</span>
							</div>
							<div 
								style={{
									width: 1,
									height: 58,
									background: "#E6E6E6",
									marginRight: 31,
								}}>
							</div>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jq3wrjrx_expires_30_days.png"} 
								style={{
									width: 24,
									height: 24,
									marginRight: 24,
									objectFit: "fill",
								}}
							/>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0vvm2zr9_expires_30_days.png"} 
								style={{
									width: 24,
									height: 24,
									objectFit: "fill",
								}}
							/>
						</div>
						<div 
							style={{
								alignSelf: "stretch",
								display: "flex",
								alignItems: "flex-start",
								marginLeft: 32,
								marginRight: 32,
							}}>
							<span 
								style={{
									color: "#010101",
									fontSize: 40,
									fontWeight: "bold",
									flex: 1,
								}} >
								{"Progress Tracking Dashboard"}
							</span>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 18,
									marginTop: 20,
								}} >
								{"Welcome Back, John Doe!"}
							</span>
						</div>
						<div 
							style={{
								alignSelf: "stretch",
								display: "flex",
								alignItems: "flex-start",
								marginLeft: 32,
								marginRight: 32,
								gap: 33,
							}}>
							<div 
								style={{
									flex: 1,
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									paddingTop: 20,
									paddingBottom: 20,
									boxShadow: "0px 1px 3px #00000003",
								}}>
								<div 
									style={{
										alignSelf: "stretch",
										display: "flex",
										alignItems: "center",
										marginBottom: 20,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 20,
											fontWeight: "bold",
											flex: 1,
										}} >
										{"Performance on Quizzes & Assignments"}
									</span>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#979797",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"View all"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ptjy0up5_expires_30_days.png"} 
											style={{
												width: 9,
												height: 9,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
								<div 
									style={{
										height: 1,
										alignSelf: "stretch",
										background: "#E6E6E6",
										marginBottom: 19,
										marginLeft: 20,
										marginRight: 20,
									}}>
								</div>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginBottom: 16,
										marginLeft: 20,
									}} >
									{"Quiz Score Overview"}
								</span>
								<button 
									style={{
										alignSelf: "stretch",
										display: "flex",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #E7F1F8, #FFFFFF)",
										borderRadius: 10,
										border: `1px solid #9DC6E4`,
										paddingTop: 16,
										paddingBottom: 16,
										paddingLeft: 17,
										paddingRight: 17,
										marginBottom: 26,
										marginLeft: 20,
										marginRight: 20,
										textAlign: "left",
									}}
									onClick={()=>alert("Pressed!")}>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 14,
											fontWeight: "bold",
											flex: 1,
										}} >
										{"average quiz score:"}
									</span>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"75%"}
									</span>
								</button>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginBottom: 16,
										marginLeft: 21,
									}} >
									{"List of Completed Quizzes"}
								</span>
								<div 
									style={{
										alignSelf: "stretch",
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 28,
										marginLeft: 21,
										marginRight: 21,
										gap: 17,
									}}>
									<div 
										style={{
											flex: 1,
											display: "flex",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											paddingTop: 13,
											paddingBottom: 13,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/iru8m0ca_expires_30_days.png"} 
											style={{
												width: 40,
												height: 40,
												marginLeft: 14,
												marginRight: 10,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flex: 1,
												display: "flex",
												flexDirection: "column",
												marginTop: 4,
												marginRight: 12,
												gap: 6,
											}}>
											<span 
												style={{
													color: "#010101",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Quiz title"}
											</span>
											<span 
												style={{
													color: "#0BBB0D",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"85% – Passed"}
											</span>
										</div>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
												fontWeight: "bold",
												marginTop: 25,
												marginBottom: 5,
												marginRight: 18,
											}} >
											{"Mar 19, 2025"}
										</span>
									</div>
									<div 
										style={{
											flex: 1,
											display: "flex",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											paddingTop: 13,
											paddingBottom: 13,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/iep5f4br_expires_30_days.png"} 
											style={{
												width: 40,
												height: 40,
												marginLeft: 14,
												marginRight: 10,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flex: 1,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												marginTop: 4,
												marginRight: 9,
												gap: 6,
											}}>
											<span 
												style={{
													color: "#010101",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Quiz title"}
											</span>
											<span 
												style={{
													color: "#EEBD10",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"50% – Needs review"}
											</span>
										</div>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
												fontWeight: "bold",
												marginTop: 25,
												marginBottom: 5,
												marginRight: 17,
											}} >
											{"Mar 19, 2025"}
										</span>
									</div>
								</div>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 14,
										fontWeight: "bold",
										marginBottom: 20,
										marginLeft: 21,
									}} >
									{"Assignment Performance"}
								</span>
								<div 
									style={{
										alignSelf: "stretch",
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 8,
										border: `1px solid #E6E6E6`,
										paddingTop: 16,
										paddingBottom: 16,
										marginLeft: 21,
										marginRight: 21,
									}}>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											alignItems: "center",
											marginBottom: 15,
											marginLeft: 19,
											marginRight: 19,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/i1plz7ay_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												marginRight: 8,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												marginRight: 149,
											}} >
											{"Business Plan Draft"}
										</span>
										<span 
											style={{
												color: "#0BBB0D",
												fontSize: 10,
												fontWeight: "bold",
												textAlign: "right",
												flex: 1,
											}} >
											{"78% (Needs Refinement)"}
										</span>
									</div>
									<div 
										style={{
											height: 1,
											alignSelf: "stretch",
											background: "#E6E6E6",
											marginBottom: 14,
											marginLeft: 19,
											marginRight: 19,
										}}>
									</div>
									<span 
										style={{
											color: "#979797",
											fontSize: 10,
											fontWeight: "bold",
											marginBottom: 8,
											marginLeft: 19,
										}} >
										{"Mentor Feedback:"}
									</span>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
											marginBottom: 15,
											marginLeft: 19,
										}} >
										{"Improve financial projections section."}
									</span>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 19,
											marginRight: 19,
											gap: 18,
										}}>
										<input
											placeholder={"Retake Quiz"}
											value={input3}
											onChange={(event)=>onChangeInput3(event.target.value)}
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
												flex: 1,
												alignSelf: "stretch",
												background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
												borderRadius: 6,
												border: "none",
												paddingTop: 9,
												paddingBottom: 9,
												paddingLeft: 66,
												paddingRight: 132,
											}}
										/>
										<div 
											style={{
												flex: 1,
												display: "flex",
												flexDirection: "column",
												background: "#FFFFFF",
												borderRadius: 6,
												border: `1px solid #00000000`,
												paddingTop: 9,
												paddingBottom: 9,
											}}>
											<span 
												style={{
													color: "#6BD0F6",
													fontSize: 12,
													fontWeight: "bold",
													textAlign: "center",
													marginLeft: 35,
													marginRight: 35,
												}} >
												{"Revise Assignment"}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div 
								style={{
									flex: 1,
									display: "flex",
									flexDirection: "column",
									gap: 33,
								}}>
								<div 
									style={{
										alignSelf: "stretch",
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										paddingTop: 20,
										paddingBottom: 20,
										boxShadow: "0px 1px 3px #00000003",
									}}>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											alignItems: "center",
											marginBottom: 20,
											marginLeft: 20,
											marginRight: 20,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 20,
												fontWeight: "bold",
												flex: 1,
											}} >
											{"Topics Revisited"}
										</span>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "center",
												gap: 8,
											}}>
											<span 
												style={{
													color: "#979797",
													fontSize: 14,
													fontWeight: "bold",
												}} >
												{"View all"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/a173m1sx_expires_30_days.png"} 
												style={{
													width: 9,
													height: 9,
													objectFit: "fill",
												}}
											/>
										</div>
									</div>
									<div 
										style={{
											height: 1,
											alignSelf: "stretch",
											background: "#E6E6E6",
											marginBottom: 22,
											marginLeft: 20,
											marginRight: 20,
										}}>
									</div>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 14,
											fontWeight: "bold",
											marginBottom: 16,
											marginLeft: 20,
										}} >
										{"List of Revisited Lessons"}
									</span>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											alignItems: "flex-start",
											marginLeft: 20,
											marginRight: 20,
											gap: 16,
										}}>
										<div 
											style={{
												flex: 1,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 8,
												border: `1px solid #E6E6E6`,
												paddingTop: 14,
												paddingBottom: 14,
												gap: 8,
											}}>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 12,
													fontWeight: "bold",
													marginLeft: 14,
													marginRight: 14,
												}} >
												{"You reviewed 'Market Research Strategies' 3 times"}
											</span>
											<div 
												style={{
													display: "flex",
													alignItems: "flex-start",
													paddingRight: 2,
													marginLeft: 14,
													gap: 4,
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ckzjuj0q_expires_30_days.png"} 
													style={{
														width: 12,
														height: 12,
														objectFit: "fill",
													}}
												/>
												<span 
													style={{
														color: "#6BD0F6",
														fontSize: 10,
														fontWeight: "bold",
													}} >
													{"Saved"}
												</span>
											</div>
										</div>
										<div 
											style={{
												flex: 1,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												background: "#FFFFFF",
												borderRadius: 8,
												border: `1px solid #E6E6E6`,
												paddingTop: 14,
												paddingBottom: 14,
												gap: 8,
											}}>
											<span 
												style={{
													color: "#2C2C2C",
													fontSize: 12,
													fontWeight: "bold",
													marginLeft: 14,
													marginRight: 14,
												}} >
												{"Revisited 'Financial Planning Basics' last week"}
											</span>
											<div 
												style={{
													display: "flex",
													alignItems: "flex-start",
													paddingRight: 2,
													marginLeft: 14,
													gap: 4,
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/64f8x5ad_expires_30_days.png"} 
													style={{
														width: 12,
														height: 12,
														objectFit: "fill",
													}}
												/>
												<span 
													style={{
														color: "#979797",
														fontSize: 10,
														fontWeight: "bold",
													}} >
													{"Save"}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div 
									style={{
										alignSelf: "stretch",
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 12,
										paddingTop: 18,
										paddingBottom: 18,
										boxShadow: "0px 1px 3px #00000003",
									}}>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											alignItems: "center",
											marginBottom: 20,
											marginLeft: 20,
											marginRight: 20,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 20,
												fontWeight: "bold",
												flex: 1,
											}} >
											{"Areas Where Additional Support is Needed"}
										</span>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												alignItems: "center",
												gap: 8,
											}}>
											<span 
												style={{
													color: "#979797",
													fontSize: 14,
													fontWeight: "bold",
												}} >
												{"View all"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8s45sxe5_expires_30_days.png"} 
												style={{
													width: 9,
													height: 9,
													objectFit: "fill",
												}}
											/>
										</div>
									</div>
									<div 
										style={{
											height: 1,
											alignSelf: "stretch",
											background: "#E6E6E6",
											marginBottom: 19,
											marginLeft: 20,
											marginRight: 20,
										}}>
									</div>
									<span 
										style={{
											color: "#979797",
											fontSize: 14,
											fontWeight: "bold",
											marginBottom: 16,
											marginLeft: 20,
											width: 315,
										}} >
										{"Identifies Weak Topics Based on Quiz Scores & Repeated Attempts"}
									</span>
									<div 
										style={{
											alignSelf: "stretch",
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											paddingTop: 14,
											paddingBottom: 14,
											marginLeft: 20,
											marginRight: 20,
											gap: 18,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												marginLeft: 19,
											}} >
											{"You may need to review 'Financial Projections' (Average Score: 45%)"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												marginLeft: 19,
											}}>
											<span 
												style={{
													color: "#F36421",
													fontSize: 11,
													fontWeight: "bold",
													marginRight: 1,
												}} >
												{"Watch Recommended Video"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/o0f87rkb_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													marginRight: 12,
													objectFit: "fill",
												}}
											/>
											<span 
												style={{
													color: "#F36421",
													fontSize: 11,
													fontWeight: "bold",
													marginRight: 1,
												}} >
												{"Ask for Mentor Guidance"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2b448iio_expires_30_days.png"} 
												style={{
													width: 15,
													height: 15,
													objectFit: "fill",
												}}
											/>
										</div>
										<div 
											style={{
												alignSelf: "stretch",
												display: "flex",
												alignItems: "flex-start",
												marginLeft: 19,
												marginRight: 19,
												gap: 18,
											}}>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
													borderRadius: 6,
													paddingTop: 8,
													paddingBottom: 8,
												}}>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 12,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 56,
														marginRight: 56,
													}} >
													{"Revisit Lesson"}
												</span>
											</div>
											<div 
												style={{
													flex: 1,
													display: "flex",
													flexDirection: "column",
													background: "#FFFFFF",
													borderRadius: 6,
													border: `1px solid #00000000`,
													paddingTop: 8,
													paddingBottom: 8,
												}}>
												<span 
													style={{
														color: "#6BD0F6",
														fontSize: 12,
														fontWeight: "bold",
														textAlign: "center",
														marginLeft: 58,
														marginRight: 58,
													}} >
													{"Practice Quiz"}
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}